import React from 'react';
import AnimatedBg from './components/AnimatedBg/AnimatedBg';
import Transition from './components/Transition/Transition';
import './App.css';

const App = () => (
  <AnimatedBg>
    <div style={{ height: '900px' }} />
    <Transition height="400px" from="#0D47A1" to="#388E3C" />
    <div style={{ height: '900px' }} />
    <Transition height="400px" from="#388E3C" to="#FFA000" position={0.75}>
      <h1>Content that appears within the transition</h1>
    </Transition>
    <div style={{ height: '900px' }} />
  </AnimatedBg>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js